import { createVNode as s, mergeProps as n } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/NoResultTwoTone.js";
import m from "../components/PfIcon.js";
const o = (e, t) => {
  const r = {
    ...e,
    ...t.attrs
  };
  return s(m, n(r, {
    icon: l
  }), null);
};
o.displayName = "NoResultTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
